import { ConflictHoarding } from "./conflictHoarding";
import { ConflictGroup } from "./conflictGroup";

export class ConflictItem {
    conflictHoardings: ConflictHoarding[] = [];
    conflictGroups: ConflictGroup[] = [];
}
